/* Hook encargado de hacer la consulta a la base y 
traer  el contenido de los body de los vehiculos

Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Brand from '../interfaces/Brand.ts'

import { makeUrlBrands } from './connectionData.tsx'

const useBrandsFetcher = () => {
  const [errorBrands, setErrorBrands] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchBrands = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlBrands()
      const data = await customFetch<Brand[]>(apiUrl)
      setErrorBrands(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorBrands(err)
      } else {
        setErrorBrands(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorBrands, loading, fetchBrands }
}

export default useBrandsFetcher
